var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaiementIconManque(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2137 24.2144C23.2137 24.707 23.0181 25.1793 22.6698 25.5276C22.3215 25.8759 21.8491 26.0716 21.3566 26.0716H4.6423C4.14975 26.0716 3.67738 25.8759 3.3291 25.5276C2.98082 25.1793 2.78516 24.707 2.78516 24.2144V3.78585C2.78516 3.29331 2.98082 2.82094 3.3291 2.47266C3.67738 2.12437 4.14975 1.92871 4.6423 1.92871H16.7137L23.2137 8.42871V24.2144Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7852 1.92871V9.35728H23.2137",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2434 21.8183C12.8634 21.9824 12.4536 22.0665 12.0397 22.065C11.1226 22.0229 10.2596 21.6193 9.63935 20.9426C9.01905 20.2659 8.69191 19.3711 8.72947 18.4539C8.69191 17.5367 9.01905 16.6419 9.63935 15.9653C10.2596 15.2886 11.1226 14.885 12.0397 14.8428C12.3735 14.841 12.7053 14.8959 13.0207 15.0053",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22266 17.5508H10.8338",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22266 19.3564H10.8338",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaiementIconManque);
export default __webpack_public_path__ + "static/media/PaiementIconManque.1c371c9aeb126c1328d63f2b34a51002.svg";
export { ForwardRef as ReactComponent };